import React from 'react';
import { useTranslation } from 'react-i18next';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Duplicate({ action, variables, setOpenVariable, visible }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DATA-TABLE.REMOVE-DUPLICATE-ROWS.';
    return (
        <div className={`conf-field-container ${visible ? "display-none" : ""}`}>
            <FieldLabel name={t(label + 'TABLE')} is_required />
            <VariablePicker action={action} inputName="assignSource" variables={variables} setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired />
            <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
        </div>
    );
}
export default Duplicate;